angular.module('app').controller('SubLineItemCtrl', function($http, $mdDialog, subLineItem, lineItem, photos, appUtils, $mdToast, $route) {
    var main = this;
    main.saving = false;
    main.current = subLineItem;
    main.updated = angular.copy(subLineItem);
    main.photos = photos;
    main.lineItem = lineItem;
    main.unit = {};

    $http({'method': 'GET', 'url': '/api/v1/admin/product/' + main.lineItem.item.product_id}).then(
        function(results) {
            main.product = results.data;
        }
    );

    main.updateUnit = function() {
        main.updated.product_id = main.unit.product.id;
        main.updated.name = main.unit.product.name;

        $http({'method': 'GET', 'url': '/api/v1/admin/product/' + main.unit.product.id}).then(
            function(results) {
                main.unit_product = results.data;
                main.options = main.unit_product.options.map(function(option) {
                    var opt = option.options;
                    opt.id = option.id;
                    return opt;
                });
            }
        );
    };

    main.updatePhoto = function(photo) {
        main.updated.photo_id = photo.id;
        main.photo = photo;
        main.save();
    };

    main.save = function() {
        if(!main.updated.id) {
            if(main.photo) {
                main.current.photo = main.photo;
                main.current.photo_id = main.photo.id;
            }

            if(main.unit.product) {
                main.current.product_id = main.unit.product.id;
                main.current.item = main.unit.product;
                main.current.options = main.updated.options;
            }

            if(main.options) {
                main.current.item.options = main.options.map(
                    function(opt) {
                        return {
                            'id': opt.id,
                            'options': opt
                        }
                    }
                );
            }

            $mdDialog.hide();
            return;
        }
        var url = '/api/v1/admin/sub_line_item/' + main.updated.id;
        delete(main.updated.item);
        delete(main.updated.photo);
        delete(main.updated.total);
        main.saving = $http({'method': 'PUT', 'url': url, 'data': main.updated}).then(
            function(results) {
                var message = "Unit saved";
                var alert = $mdToast.simple().textContent(message);
                $mdToast.show(alert);
                $mdDialog.hide();
                $route.reload();
            }
        );
    };
});
